import { getStoryBySlug } from '@cinch-nx/data-storyblok'
import { traceFunction } from '@core/datadog-server'
import { GetStaticPropsContext, InferGetStaticPropsType } from 'next'
import { autotraderFallbackStory } from './storyblok/data/fallback-json'
import { AutotraderStory } from './storyblok/storyblok'

const isDev = process.env.STAGE_NAME !== 'production'
const STORYBLOK_BFF_URL = 'https://storyblok-bff.snc-prod.aws.cinch.co.uk'

async function getStory(preview: boolean) {
  try {
    return await getStoryBySlug<AutotraderStory>(
      'autotrader',
      {
        version: preview || isDev ? 'draft' : 'published',
      },
      { strict: true, urlDomain: STORYBLOK_BFF_URL },
    )
  } catch {
    return autotraderFallbackStory
  }
}

export async function getStaticPropsfn({
  preview = false,
}: GetStaticPropsContext) {
  const story = await getStory(preview)

  return {
    props: {
      story,
      preview,
      layoutProps: {
        heroProps: story.content.hero[0],
        showBorderRadius: true,
      },
    },
    revalidate: 60,
  }
}

export const getStaticProps = traceFunction(
  'autotrader.getStaticProps',
  getStaticPropsfn,
)

export type AutotraderProps = InferGetStaticPropsType<typeof getStaticProps>
